import { render, staticRenderFns } from "./StartBroadcastModal.vue?vue&type=template&id=a6bd6014&scoped=true&"
import script from "./StartBroadcastModal.vue?vue&type=script&lang=js&"
export * from "./StartBroadcastModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd6014",
  null
  
)

export default component.exports